<template>
  <div class="form-field invalid">
    <label class="form-label">
      Job title

      <span class="mandatory-marker">
        *
      </span>
    </label>

    <input v-model="mutable.jobTitle"
           placeholder="Job title"
           class="form-control"
           :class="{ invalid: showValidation && !isValid }">

    <span v-if="showValidation && !isValid"
          class="validation-message">
      Required
    </span>
  </div>
</template>

<script>
import vmodelMixin from "~/mixins/vmodelMixin";
import validationMixin from "~/mixins/validationMixin";

export default {
  name: "FreeTextJobCollectionMethod",
  mixins: [vmodelMixin, validationMixin],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ( {
    mutable: null
  } ),
  computed: {
    isValid () {
      let result = true;

      if ( !this.mutable.jobTitle ) {
        result = false;
      }

      return result;
    }
  },
  watch: {
    mutable: {
      deep: true,
      handler () {
        this.validate();
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>
